<template>
  <div>

    <div class="member">
      <div class="Pic">

        <!-- <div v-if="formData.openFlag" v-loading="loadingImg" v-show="loadingImg" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading" style="margin:10% 0;"></div> style="position: absolute;visibility: hidden;"  -->
        <img v-if="formData.openFlag" :src="imgUrl" style="width:375px" />
        <div v-show="!imgUrl&&formData.openFlag" class="meetImg" ref="imageDom">
          <div
            style=" background-color: #fff;border: 1px solid rgba(187, 187, 187, 1);border-radius: 9px;padding-top: 20px;">
            <!-- <img :src="imgUrl" style="width:100%" /> -->
            <h3 style="line-height: 28px;color: black;">
              <span style="width: 238px;
            display: block;
            margin: 0 auto;">{{formData.topCopywritingLeft}}<span
                  v-if="formData.name">{{userInfo.name}}</span><span>{{formData.topCopywritingTwo}}</span></span>
            </h3>
            <div class="qrEwm" id="qrcodeEm">
              <vue-qr :text="config.text" :correctLevel="3" :size="300" :margin="10" colorLight="white"
                backgroundColor="white" backgroundDimming="white" :logoSrc="config.logo" :logoScale="0.2"
                :logoMargin="5" logoBackgroundColor="white">
              </vue-qr>
            </div>
            <p style="margin: 0 auto 23px;font-size: 14px;">{{formData.midCopywriting}}</p>
            <div style="display: flex;justify-content: space-around;margin-bottom: 20px;">
              <div style="width:48%;height:32px ;">
                <img style="width: 100%;height: 100%;object-fit: contain;" v-if="formData.leftLogo"
                  :src="formData.leftLogo">
              </div>
              <div style="width:48%;height:32px ;">
                <img style="width: 100%;height: 100%;object-fit: contain;" v-if="formData.rightLogo"
                  :src="formData.rightLogo">
              </div>
            </div>
            <div style="padding: 0 0 23px;font-size: 14px;">
              {{formData.bottomCopywriting}}
            </div>
          </div>
        </div>
        <div class="warntip" v-if="formData.openFlag">
          <p class="tips" style="font-size: 14px;">分享方式</p>
          <p class="tips">
            <span class="circle"></span>
            <span style="font-size: 12px;">可长按图片，选择保存到手机或转发给朋友。</span>
          </p>
          <p class="tips">
            <span class="circle"></span>
            <span style="font-size: 12px;">点击手机右上角 • • • ，选择分享到朋友圈或分享给朋友。</span>
          </p>
          <p class="tips">
            <span class="circle"></span>
            <span style="font-size: 12px;">复制海报链接发送给朋友。 <van-button :icon="copy" type="primary"
                @click="copyLink">复制海报链接</van-button></span>
          </p>
        </div>

        <!-- <span slot="footer" class="dialog-footer" v-else style="color:#6c6c6c">
          海报分享未开启
        </span> -->
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
  import { FORMAL_URL } from "@/utils/http.js";
  import {
    memberShareGet, getPZUrl, getUser, getVoteWxConfig
  } from "@/api/dictionary";

  import vueQr from 'vue-qr'
  import html2canvas from "html2canvas";
  import vHead from "../../components/Subhead.vue";
  import { Field, Button, Toast, CellGroup, Dialog, Icon } from "vant";
  export default {
    data() {
      return {
        config: {
          logo: require("@/assets/images/logo3.png"),
          text: ""
        },
        loadingImg: false,
        imgUrl: '',
        share: '',
        copy: '',
        userInfo: { name: '' },
        codeUrlSign: '',
        logo: '',
        formData: {
          openFlag: false,
          topCopywritingLeft: '',
          name: '',
          topCopywritingTwo: '',
          midCopywriting: '',
          bottomCopywriting: '',
          leftLogo: '',
          rightLogo: '',
        },
      }
    },
    components: {
      vHead,
      [Button.name]: Button,
      [Toast.name]: Toast,
      [CellGroup.name]: CellGroup,
      [Dialog.name]: Dialog,
      [Icon.name]: Icon,
      vueQr
    },
    computed: {
      // ...mapState(["userInfo"])
    },

    methods: {
      clickGeneratePicture() {
        this.loadingImg = true;
        //生成图片
        this.$nextTick(() => {
          html2canvas(this.$refs.imageDom).then((canvas) => {
            // 转成图片，生成图片地址
            this.imgUrl = canvas.toDataURL("image/png", 0.5); //可将 canvas 转为 base64 格式
            this.loadingImg = false;
          });
        });
      },
      getUserInfo() {
        getUser().then(res => {
          if (res.success) {
            this.userInfo = res.result;
          }
        })
      },
      getData() {
        let params = {
          code: 'member.share.setting'
        }
        memberShareGet(params).then(async res => {
          console.log('params', res)
          if (res.success) {
            try {
              this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
            } catch (error) {
              console.log("userInfo parse err", error)
            }
            this.formData = res.result
            this.config.text = FORMAL_URL + '/mobile/#/login?id=' + this.userInfo.userId

            if (!res.result.openFlag) {
              this.formData.openFlag = false
            }
            if (!res.result.name) {
              this.formData.name = false
            }
            // if (res.result.leftLogo) {
            //   this.formData.leftLogo = FORMAL_URL + "/htdocs/" + res.result.leftLogo;
            // }
            // if (res.result.rightLogo) {
            //   this.formData.rightLogo = FORMAL_URL + "/htdocs/" + res.result.rightLogo;
            // }
            // this.clickGeneratePicture()

            if (res.result.leftLogo || res.result.rightLogo) {
              this.getPZUrl(res.result)
            }
            if (!res.result.leftLogo && !res.result.rightLogo) { //两个海报都没有
              this.clickGeneratePicture()
            }
            this.wxConfigInit();
          }
        })
      },
      getPZUrl(form) {
        // 如果都有
        if (form.leftLogo && form.rightLogo) {
          getPZUrl({ id: form.leftLogo }).then((res) => {
            if (res.success) {
              this.formData.leftLogo = res.result;
              getPZUrl({ id: form.rightLogo }).then((resp) => {
                if (resp.success) {
                  this.formData.rightLogo = resp.result;
                  setTimeout(() => {
                    this.clickGeneratePicture()
                  }, 200)
                }
              })
            }

          })
        } else {
          // 如果只有一个有
          if (form.leftLogo) {
            getPZUrl({ id: form.leftLogo }).then((res) => {
              if (res.success) {
                this.formData.leftLogo = res.result;
                this.clickGeneratePicture()
              }
            })
          }
          if (form.rightLogo) {
            getPZUrl({ id: form.rightLogo }).then((res) => {
              if (res.success) {
                this.formData.rightLogo = res.result;
                this.clickGeneratePicture()
              }
            })
          }
        }

      },
      copyLink() {
        console.log('this.userInfo', this.userInfo)
        var company =
          FORMAL_URL + '/mobile/#/share?id=' + this.userInfo.userId

        const inputNode = document.createElement("input")
        inputNode.value = company
        document.body.appendChild(inputNode)
        inputNode.select()
        document.execCommand("Copy")
        Toast.success("复制成功") //这是element plus提示用户复制成功的信息提醒，根据自己实际需求加
        document.body.removeChild(inputNode)
      },
      //初始化微信分享配置
      wxConfigInit() {
        var shareImgUrl = FORMAL_URL + '/web/static/img/logo3.png';
        var lineLink = FORMAL_URL + "/mobile/#/share?id=" + this.userInfo.userId;
        var descContent = this.formData.topCopywritingLeft;
        if (this.formData.name) {
          descContent = descContent + this.userInfo.name
        }
        descContent = descContent + this.formData.topCopywritingTwo
        var shareTitle = descContent;
        var currUrl = decodeURIComponent(location.href.split('#')[0]);
        getVoteWxConfig({ requestUrl: currUrl }).then(response => {
          console.log("wx res", response)
          var appId = response.appId;
          var timestamp = response.timestamp;
          var nonceStr = response.nonceStr;
          var signature = response.signature;
          wx.config({
            debug: false,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: [
              'updateTimelineShareData',
              'updateAppMessageShareData'
            ]
          });
          wx.ready(function () {
            wx.updateTimelineShareData({
              title: '入会邀请', // 分享标题
              link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareImgUrl, // 分享图标
              success: function () {
                console.log(111)
              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            });
            wx.updateAppMessageShareData({
              title: '入会邀请', // 分享标题
              desc: shareTitle, // 分享描述
              link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareImgUrl, // 分享图标
              type: '', // 分享类型,music、video或link，不填默认为link
              dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function () {
                // 用户确认分享后执行的回调函数
                console.log(222)

              },
              cancel: function () {
                // 用户取消分享后执行的回调函数
              }
            });
          });
        })
      }
    },
    created() {
      this.getData()
      // this.getUserInfo()
    },
    mounted: async function () {
      this.logo = require("../../assets/images/logo3.png");
      this.share = require("../../assets/images/user/分享 icon.png");
      this.copy = require("../../assets/images/user/复制.png");
    }
  };
</script>
<style scoped lang="less">
  .member {
    text-align: center;
  }

  .Pic {
    margin: 0 auto;
  }

  .dialog-footer {
    display: flex;
    justify-content: space-around;
    margin-top: 80px;
  }

  .warntip {
    background-color: #F4F7FA;
    text-align: left;
    border-radius: 3px;
    padding: 15px 0 15px 15px;
    margin: 0 18px 60px;
  }

  .tips {
    margin-bottom: 19px;
  }

  .circle {
    margin-right: 10px;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: rgba(248, 95, 37, 1);
  }

  .qrcode-logo {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 72px;
  }

  .qrEwm {
    margin-bottom: 15px;
    position: relative;
  }

  .van-button {
    height: 28px;
    font-size: 12px;
    padding: 3px;
    border-radius: 4px;

    /deep/.van-button__text {
      font-size: 12px;
    }
  }

  .meetImg {
    /* background: #6c6c6c; */
    padding: 17px 21px;
    margin-bottom: 10px;

    h3 {
      span {
        font-size: 14px;
      }
    }
  }
</style>